<style scope>
  .w-full { width: 100% }
</style>

<template>
  <section class="container">

    <portal-box style="min-height: 600px">
      <h1 slot="titulo" class="title">
        <b-field>
          <b-radio-button v-model="tipoSelecionado" :disabled="loading"
                          native-value="mesCorrenteFabrica"
                          type="is-primary">
            <span>Mês corrente (Fábrica)</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado" :disabled="loading"
                          native-value="pedidoFabrica"
                          type="is-primary">
            <span>Pedidos (Fábrica)</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado" :disabled="loading"
                          native-value="mesCorrentePortal"
                          type="is-primary">
            <span>Mês corrente (Portal)</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado" :disabled="loading"
                          native-value="pedidoPortal"
                          type="is-primary">
            <span>Pedidos (Portal)</span>
          </b-radio-button>
        </b-field>
      </h1>

      <template v-if="tipoSelecionado !== 'pedidoPortal' && tipoSelecionado !== 'mesCorrentePortal'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="Faturado?">
            <b-select v-model="filtro.faturado" placeholder="já foi faturado?">
              <option :value="'sim'" :key="'sim'">Sim</option>
              <option :value="'nao'" :key="'nao'">Não</option>
            </b-select>
          </b-field>

          <b-field label="Cliente">
            <b-input v-model="filtro.clienteParam" placeholder="Razão social">
            </b-input>
          </b-field>

          <b-field label="Código do pedido">
            <b-input v-model="filtro.pedidoParam" placeholder="código ou código web">
            </b-input>
          </b-field>

          <b-field label="Pedido original" v-if="parametros.EMPRESA_NOME === 'FERMOPLAST'">
            <b-input v-model="filtro.pedidoOriginal" placeholder="código do pedido original">
            </b-input>
          </b-field>

          <label class="label" v-if="tipoSelecionado === 'pedidoFabrica'">Emissão</label>
          <b-field v-if="tipoSelecionado === 'pedidoFabrica'">
            <b-datepicker placeholder="Início" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Fim" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Último faturamento</label>
          <b-field>
            <b-datepicker placeholder="Início" v-model="filtro.faturamentoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.faturamentoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Fim" v-model="filtro.faturamentoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.faturamentoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
        <!-- botao gerar novo pedido -->
        <router-link class="button is-primary" to="/pedido/novo">
          <b-icon icon="plus-box"/>
          <span>Novo</span>
        </router-link>
      </template>

      <template v-else slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="Cliente">
            <b-input v-model="filtro.clienteParam" placeholder="Razão social">
            </b-input>
          </b-field>

          <b-field label="Código do pedido">
            <b-input v-model="filtro.pedidoParam" placeholder="código ou código web">
            </b-input>
          </b-field>

          <label class="label">Emissão</label>
          <b-field>
            <b-datepicker placeholder="Início" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Fim" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>

        <router-link class="button is-primary" to="/pedido/novo">
          <b-icon icon="plus-box"/>
          <span>Novo</span>
        </router-link>
      </template>

      <lista-fabrica :lista="lista" :loading="loading" :parametros="parametros"
                     v-if="tipoSelecionado !== 'pedidoPortal' && tipoSelecionado !== 'mesCorrentePortal'"></lista-fabrica>

      <lista-portal :lista="lista" :loading="loading" :parametros="parametros" v-else></lista-portal>

    </portal-box>
  </section>
</template>

<script>
  import { auth } from '../../mixins/auth'
  import { listagem } from '../../mixins/listagem'
  import ListaFabrica from './ListaFabrica'
  import ListaPortal from './ListaPortal'

  export default {
    mixins: [auth, listagem],
    components: {ListaFabrica, ListaPortal},
    created () {
      this.url = this.$URL.PEDIDO.MES_CORRENTE + 'fabrica'
      this.metodo = 'PUT'
    },
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/pedido/consulta').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    data () {
      return {
        tipoSelecionado: 'mesCorrenteFabrica'
      }
    },
    methods: {
      filtrarSelecionado () {
        if (this.tipoSelecionado === 'mesCorrenteFabrica') {
          this.url = this.$URL.PEDIDO.MES_CORRENTE + 'fabrica'
        } else if (this.tipoSelecionado === 'mesCorrentePortal') {
          this.url = this.$URL.PEDIDO.MES_CORRENTE + 'portal'
        } else if (this.tipoSelecionado === 'pedidoFabrica') {
          this.url = this.$URL.PEDIDO.LISTA_FILTRADA + 'fabrica'
        } else {
          this.url = this.$URL.PEDIDO.LISTA_FILTRADA + 'portal'
        }
        this.filtrar()
      },
      limparFiltro () {
        this.filtro = {}
        this.filtrarSelecionado()
      }
    },
    watch: {
      tipoSelecionado (value) {
        this.lista = []
        this.limparFiltro()
      }
    },
    computed: {
      parametros () {
        return this.$store.state.parametros
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pedido/Lista.vue